(() => {
  const moneyFormat =
    window.theme && window.theme.moneyFormat
      ? window.theme.moneyFormat
      : "${{amount}}";

  function formatMoney(cents) {
    const value = (Number(cents) / 100).toFixed(2);
    const parts = value.split(".");
    const withComma = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") + (parts[1] ? "." + parts[1] : "");
    return moneyFormat
      .replace("{{amount}}", withComma)
      .replace("{{amount_no_decimals}}", parts[0])
      .replace("{{amount_with_comma_separator}}", withComma.replace(".", ","))
      .replace("{{amount_no_decimals_with_comma_separator}}", parts[0]);
  }

  function $(sel, root = document) {
    return root.querySelector(sel);
  }
  function $all(sel, root = document) {
    return Array.from(root.querySelectorAll(sel));
  }

  function toast(msg) {
    let el = $(".toast");
    if (!el) {
      el = document.createElement("div");
      el.className = "toast";
      el.setAttribute("role", "status");
      document.body.appendChild(el);
    }
    el.textContent = msg;
    el.classList.add("is-on");
    clearTimeout(toast._t);
    toast._t = setTimeout(() => el.classList.remove("is-on"), 2200);
  }

  async function fetchCart() {
    const res = await fetch("/cart.js", { headers: { Accept: "application/json" } });
    return res.json();
  }

  function setCartCount(count) {
    $all("[data-cart-count]").forEach((el) => {
      el.dataset.count = String(count);
      el.textContent = count > 0 ? String(count) : "";
    });
  }

  function lineSellingLabel(item) {
    const spa = item.selling_plan_allocation;
    if (!spa) return "One-time purchase";
    return (spa.selling_plan && spa.selling_plan.name) || "Subscribe";
  }

  function lineMoney(item) {
    const qty = Number(item.quantity || 1);
    const spa = item.selling_plan_allocation;
    const charged = Number(
      item.final_line_price != null ? item.final_line_price : item.line_price || 0
    );
    let list = Number(item.original_line_price || 0);
    if (spa) {
      const compare = Number(spa.compare_at_price || item.original_price || 0);
      if (compare) list = compare * qty;
    }
    return { list, charged };
  }

  function renderCart(cart) {
    const root = $("[data-cart-drawer]");
    if (!root) return;
    setCartCount(cart.item_count);
    const empty = $("[data-cart-empty]", root);
    const lines = $("[data-cart-lines]", root);
    const foot = $("[data-cart-foot]", root);
    const total = $("[data-cart-total]", root);
    const save = $("[data-cart-save]", root);

    const hasItems = Array.isArray(cart.items) && cart.items.length > 0;
    root.classList.toggle("is-cart-empty", !hasItems);
    if (!hasItems) {
      if (empty) {
        empty.hidden = false;
        empty.classList.remove("is-hidden");
      }
      if (lines) {
        lines.hidden = true;
        lines.classList.add("is-hidden");
        lines.innerHTML = "";
      }
      if (foot) {
        foot.hidden = true;
        foot.classList.add("is-hidden");
      }
      return;
    }
    if (empty) {
      empty.hidden = true;
      empty.classList.add("is-hidden");
    }
    if (lines) {
      lines.hidden = false;
      lines.classList.remove("is-hidden");
      lines.innerHTML = cart.items
        .map((item) => {
          const img = item.featured_image
            ? item.featured_image.url
            : item.image || "";
          const plan = lineSellingLabel(item);
          const money = lineMoney(item);
          const priceHtml =
            item.selling_plan_allocation && money.list > money.charged
              ? `<s>${formatMoney(money.list)}</s> ${formatMoney(money.charged)}`
              : formatMoney(money.charged);
          return `<li class="cart-line" data-key="${item.key}">
            <img src="${img}" alt="">
            <div>
              <h3>${item.product_title}</h3>
              <p class="meta">${item.variant_title ? item.variant_title + " · " : ""}${plan}</p>
              <p class="price">${priceHtml}</p>
              <div class="qty">
                <div class="qty-ctrl">
                  <button type="button" data-qty="-1" aria-label="Decrease quantity">−</button>
                  <span>${item.quantity}</span>
                  <button type="button" data-qty="1" aria-label="Increase quantity">+</button>
                </div>
                <button type="button" class="cart-remove" data-remove>Remove</button>
              </div>
            </div>
          </li>`;
        })
        .join("");
    }
    if (foot) {
      foot.hidden = false;
      foot.classList.remove("is-hidden");
    }
    let chargedTotal = 0;
    let savedTotal = 0;
    cart.items.forEach((i) => {
      const money = lineMoney(i);
      chargedTotal += money.charged;
      if (i.selling_plan_allocation && money.list > money.charged) {
        savedTotal += money.list - money.charged;
      }
    });
    if (total) total.textContent = formatMoney(cart.total_price);
    if (save) {
      if (savedTotal > 0) {
        save.hidden = false;
        save.textContent = `You're saving ${formatMoney(savedTotal)} with Subscribe & Save`;
      } else {
        save.hidden = true;
      }
    }
  }

  async function changeLine(key, quantity) {
    try {
      const res = await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: key, quantity }),
      });
      const json = await res.json();
      if (!json.items) {
        toast(json.description || json.message || "Could not update cart");
        renderCart(await fetchCart());
        return;
      }
      renderCart(json);
    } catch (err) {
      toast("Could not update cart");
    }
  }

  function focusable(root) {
    return $all(
      'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])',
      root
    ).filter((el) => !el.hasAttribute("disabled") && el.getAttribute("aria-hidden") !== "true");
  }

  let drawerLastFocus = null;

  function setDrawerExpanded(name, open) {
    $all('[data-open-drawer="' + name + '"]').forEach((btn) => {
      btn.setAttribute("aria-expanded", String(open));
    });
  }

  function openDrawer(name, trigger) {
    const el = document.querySelector(`[data-drawer="${name}"]`);
    if (!el) return;
    drawerLastFocus = trigger || document.activeElement;
    el.classList.add("is-open");
    el.setAttribute("aria-hidden", "false");
    document.body.classList.add("drawer-lock");
    document.querySelector(".site-header")?.classList.remove("is-hidden");
    setDrawerExpanded(name, true);
    const panel = el.querySelector(".drawer-panel") || el;
    window.setTimeout(() => {
      const items = focusable(panel);
      (items[0] || panel).focus();
    }, 30);
  }
  function closeDrawer(name) {
    const el = document.querySelector(`[data-drawer="${name}"]`);
    if (!el) return;
    el.classList.remove("is-open");
    el.setAttribute("aria-hidden", "true");
    setDrawerExpanded(name, false);
    if (!$(".drawer-root.is-open")) document.body.classList.remove("drawer-lock");
    if (drawerLastFocus && typeof drawerLastFocus.focus === "function") {
      drawerLastFocus.focus();
    }
  }

  function initDrawers() {
    document.addEventListener("click", (e) => {
      const openBtn = e.target.closest("[data-open-drawer]");
      if (openBtn) {
        openDrawer(openBtn.getAttribute("data-open-drawer"), openBtn);
        return;
      }
      const closeBtn = e.target.closest("[data-close-drawer]");
      if (closeBtn) {
        closeDrawer(closeBtn.getAttribute("data-close-drawer"));
      }
    });
    document.addEventListener("keydown", (e) => {
      const open = $(".drawer-root.is-open");
      if (!open) return;
      if (e.key === "Escape") {
        const name = open.getAttribute("data-drawer");
        closeDrawer(name);
        return;
      }
      if (e.key !== "Tab") return;
      const panel = open.querySelector(".drawer-panel") || open;
      const items = focusable(panel);
      if (!items.length) return;
      const first = items[0];
      const last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });
    const cartRoot = $("[data-cart-drawer]");
    if (cartRoot) {
      cartRoot.addEventListener("click", async (e) => {
        const line = e.target.closest(".cart-line");
        if (!line) return;
        const key = line.getAttribute("data-key");
        if (e.target.closest("[data-remove]")) {
          await changeLine(key, 0);
          return;
        }
        const qtyBtn = e.target.closest("[data-qty]");
        if (qtyBtn) {
          const span = line.querySelector(".qty-ctrl span");
          const next = Math.max(0, Number(span.textContent) + Number(qtyBtn.getAttribute("data-qty")));
          await changeLine(key, next);
        }
      });
    }
  }

  function currentAlloc(v) {
    const allocs = (v && v.allocations) || [];
    const discounted = allocs.find((a) => a.price && v.price && Number(a.price) < Number(v.price));
    return discounted || allocs[0] || null;
  }

  function initOffer() {
    const root = $("[data-offer]");
    if (!root) return;
    const form = $("[data-product-form]", root);
    const dataEl = $("#ranch-product-json");
    let data = { variants: [] };
    try {
      if (dataEl && dataEl.textContent) data = JSON.parse(dataEl.textContent);
    } catch (e) {
      /* keep defaults */
    }
    const variants = data.variants || [];
    window.ranchProduct = data;
    let variantId = data.default_variant_id || (variants[1] || variants[0] || {}).id;

    const variantInput = $("[data-variant-input]", root);
    const planInput = $("[data-plan-input]", root);
    const atc = $("[data-atc]", root);
    const atcLabel = $("[data-atc-label]", root);

    function currentVariant() {
      return variants.find((v) => String(v.id) === String(variantId)) || variants[0];
    }
    function variantHasSub(v) {
      return !!(v && v.allocations && v.allocations.length);
    }
    function subPrice(v) {
      const alloc = currentAlloc(v);
      if (!alloc) return Number(v.price);
      if (alloc.price != null) return Number(alloc.price);
      if (alloc.per_delivery_price != null) return Number(alloc.per_delivery_price);
      return Number(v.price);
    }
    function savePct(v) {
      const list = Number(v.price);
      const sub = subPrice(v);
      if (!list || sub >= list) return 0;
      return Math.round(((list - sub) * 100) / list);
    }
    let plan = variantHasSub(currentVariant()) ? "subscribe" : "onetime";
    if (currentVariant() && currentVariant().available === false) {
      const firstLive = variants.find((v) => v.available);
      if (firstLive) variantId = firstLive.id;
      plan = variantHasSub(currentVariant()) ? "subscribe" : "onetime";
    }
    function syncInputs() {
      const v = currentVariant();
      if (!v) return;
      if (variantInput) variantInput.value = String(v.id);
      const alloc = currentAlloc(v);
      if (planInput) {
        if (plan === "subscribe" && alloc && alloc.plan_id) {
          planInput.setAttribute("name", "selling_plan");
          planInput.value = String(alloc.plan_id);
          planInput.disabled = false;
        } else {
          planInput.removeAttribute("name");
          planInput.value = "";
          planInput.disabled = true;
        }
      }
    }
    function sync() {
      const v = currentVariant();
      if (!v) return;
      if (plan === "subscribe" && !variantHasSub(v)) plan = "onetime";
      $all("[data-pack]", root).forEach((btn) => {
        const on = String(btn.dataset.pack) === String(v.id);
        btn.classList.toggle("is-selected", on);
        btn.setAttribute("aria-checked", String(on));
      });
      $all("[data-plan]", root).forEach((btn) => {
        const on = btn.dataset.plan === plan;
        btn.classList.toggle("is-selected", on);
        btn.setAttribute("aria-checked", String(on));
        if (btn.dataset.plan === "subscribe") {
          btn.hidden = !variantHasSub(v);
        }
      });
      $all("[data-onetime-price]", root).forEach((el) => {
        el.textContent = formatMoney(v.price);
      });
      $all("[data-sub-price]", root).forEach((el) => {
        el.textContent = formatMoney(subPrice(v));
      });
      $all("[data-save-amount]", root).forEach((el) => {
        el.textContent = formatMoney(Math.max(0, Number(v.price) - subPrice(v)));
      });
      const chip = $("[data-save-chip]", root);
      if (chip) {
        const pct = savePct(v);
        chip.hidden = pct <= 0;
        if (pct > 0) chip.textContent = pct + "% OFF";
      }
      const price = plan === "subscribe" && variantHasSub(v) ? subPrice(v) : v.price;
      if (atc) atc.disabled = v.available === false;
      if (atcLabel) {
        atcLabel.textContent =
          v.available === false ? `${v.title} · Sold out` : `Add ${v.title} · ${formatMoney(price)}`;
      }
      syncInputs();
    }

    root.addEventListener("click", (e) => {
      const pack = e.target.closest("[data-pack]");
      if (pack) {
        if (pack.disabled || pack.getAttribute("data-available") === "false") return;
        variantId = pack.dataset.pack;
        sync();
        return;
      }
      const planBtn = e.target.closest("[data-plan]");
      if (planBtn) {
        plan = planBtn.dataset.plan;
        sync();
      }
    });
    root.addEventListener("keydown", (e) => {
      const pack = e.target.closest("[data-pack]");
      if (!pack) return;
      if (e.key !== "ArrowRight" && e.key !== "ArrowLeft" && e.key !== "ArrowUp" && e.key !== "ArrowDown") return;
      e.preventDefault();
      const packs = $all("[data-pack]:not([disabled])", root);
      const i = packs.indexOf(pack);
      const dir = e.key === "ArrowRight" || e.key === "ArrowDown" ? 1 : -1;
      const next = packs[(i + dir + packs.length) % packs.length];
      if (next) {
        variantId = next.dataset.pack;
        next.focus();
        sync();
      }
    });

    async function addToCart(e) {
      if (e) e.preventDefault();
      const v = currentVariant();
      if (!v) {
        if (form) form.submit();
        return;
      }
      if (!v.available) {
        toast("That pack is sold out");
        if (atc) atc.disabled = false;
        return;
      }
      if (atc) atc.disabled = true;
      syncInputs();
      const body = new FormData();
      body.append("id", String(v.id));
      body.append("quantity", "1");
      const alloc = currentAlloc(v);
      if (plan === "subscribe" && alloc && alloc.plan_id) {
        body.append("selling_plan", String(alloc.plan_id));
      }
      try {
        const res = await fetch("/cart/add.js", {
          method: "POST",
          headers: { Accept: "application/json" },
          body,
        });
        const json = await res.json().catch(() => ({}));
        if (!res.ok) {
          throw new Error(json.description || json.message || "Could not add to cart");
        }
        const cart = await fetchCart();
        renderCart(cart);
        toast(`${v.title} added to cart`);
        openDrawer("cart", atc);
      } catch (err) {
        toast(err.message || "Could not add to cart");
      } finally {
        if (atc) atc.disabled = false;
      }
    }

    if (form) form.addEventListener("submit", addToCart);
    else if (atc) atc.addEventListener("click", addToCart);

    sync();
  }

  function initAccordion() {
    $all("[data-acc]").forEach((root) => {
      $all("[data-acc-item]", root).forEach((item, i) => {
        const btn = item.querySelector("[data-acc-trigger]");
        const panel = item.querySelector(".acc-panel");
        if (!btn || !panel) return;
        const id = panel.id || "acc-panel-" + Math.random().toString(36).slice(2, 8) + i;
        panel.id = id;
        btn.setAttribute("aria-controls", id);
        btn.setAttribute("aria-expanded", item.classList.contains("is-open") ? "true" : "false");
      });
      root.addEventListener("click", (e) => {
        const trigger = e.target.closest("[data-acc-trigger]");
        if (!trigger) return;
        const item = trigger.closest("[data-acc-item]");
        const open = item.classList.contains("is-open");
        $all("[data-acc-item]", root).forEach((it) => {
          it.classList.remove("is-open");
          it.querySelector("[data-acc-trigger]")?.setAttribute("aria-expanded", "false");
        });
        if (!open) {
          item.classList.add("is-open");
          trigger.setAttribute("aria-expanded", "true");
        }
      });
    });
  }

  function inView(el) {
    if (!el) return false;
    const r = el.getBoundingClientRect();
    const vh = window.innerHeight;
    return r.bottom > 48 && r.top < vh - 48;
  }

  function initSticky() {
    const bar = $("[data-sticky-atc]");
    if (!bar) return;
    const hero = document.getElementById("hero");
    const shop = document.getElementById("shop");
    if (!hero || !shop) {
      bar.classList.remove("is-visible");
      bar.setAttribute("hidden", "");
      return;
    }
    const fin = document.getElementById("final-cta");
    const sync = () => {
      const pastHero = hero.getBoundingClientRect().bottom < 72;
      bar.classList.toggle("is-visible", pastHero && !inView(shop) && !inView(fin));
      if (bar.classList.contains("is-visible")) {
        document.documentElement.style.setProperty("--sticky-atc-h", bar.getBoundingClientRect().height + "px");
      }
      const teaser = document.querySelector("[data-rpop-teaser]");
      if (teaser && !teaser.hidden) {
        const cs = getComputedStyle(bar);
        const lift =
          bar.classList.contains("is-visible") && cs.display !== "none"
            ? Math.round(bar.getBoundingClientRect().height)
            : 0;
        teaser.style.bottom =
          "calc(" + (lift ? lift + 12 : 14) + "px + env(safe-area-inset-bottom, 0px))";
      }
    };
    sync();
    window.addEventListener("scroll", sync, { passive: true });
    window.addEventListener("resize", sync);
    bar.addEventListener("click", (e) => {
      if (e.target.closest("[data-sticky-shop]")) {
        shop?.scrollIntoView({ behavior: "smooth" });
      }
    });
  }

  function starRow(score) {
    const n = Number(score) || 0;
    let html = '<span class="stars" role="img" aria-label="' + n + ' out of 5 stars">';
    for (let i = 0; i < 5; i++) {
      const fill = Math.max(0, Math.min(1, n - i));
      const clip = (1 - fill) * 100;
      html +=
        '<span style="position:relative;width:16px;height:16px;display:inline-block">' +
        '<svg width="16" height="16" viewBox="0 0 24 24" fill="#e0b784" style="opacity:.35" aria-hidden="true"><path d="M12 .587l3.668 7.431L24 9.753l-6 5.848 1.416 8.268L12 19.771l-7.416 4.098L6 15.601 0 9.753l8.332-1.735z"/></svg>' +
        (fill > 0
          ? '<svg width="16" height="16" viewBox="0 0 24 24" fill="#f0b429" style="position:absolute;inset:0;clip-path:inset(0 ' +
            clip +
            '% 0 0)" aria-hidden="true"><path d="M12 .587l3.668 7.431L24 9.753l-6 5.848 1.416 8.268L12 19.771l-7.416 4.098L6 15.601 0 9.753l8.332-1.735z"/></svg>'
          : "") +
        "</span>";
    }
    return html + "</span>";
  }

  function parseJudgeReviews(html) {
    const doc = new DOMParser().parseFromString(html, "text/html");
    return Array.from(doc.querySelectorAll(".jdgm-rev")).map((el) => ({
      verified: el.getAttribute("data-verified-buyer") === "true",
      score: Number(el.querySelector(".jdgm-rev__rating")?.getAttribute("data-score") || 5),
      author: (el.querySelector(".jdgm-rev__author")?.textContent || "Anonymous").trim(),
      title: (el.querySelector(".jdgm-rev__title")?.textContent || "").trim(),
      body: (el.querySelector(".jdgm-rev__body")?.textContent || "").trim(),
      date: el.querySelector("time")?.getAttribute("datetime") || ""
    }));
  }

  function formatReviewDate(iso) {
    if (!iso) return "";
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return "";
    return d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
  }

  function pagerButtons(page, pages) {
    const items = [];
    const push = (n, label, current) => items.push({ n, label: label || String(n), current: !!current, gap: false });
    push(Math.max(1, page - 1), "Prev");
    const windowed = new Set([1, pages, page, page - 1, page + 1]);
    let last = 0;
    for (let i = 1; i <= pages; i++) {
      if (!windowed.has(i) && !(i <= 2) && !(i >= pages - 1)) continue;
      if (last && i - last > 1) items.push({ gap: true });
      push(i, String(i), i === page);
      last = i;
    }
    push(Math.min(pages, page + 1), "Next");
    return items;
  }

  function initJLive() {
    const root = document.querySelector("[data-jlive]");
    if (!root) return;
    const grid = root.querySelector("[data-jlive-grid]");
    const pager = root.querySelector("[data-jlive-pager]");
    const error = root.querySelector("[data-jlive-error]");
    const countEl = root.querySelector("[data-jlive-count]");
    const scoreEl = root.querySelector("[data-jlive-score]");
    const shop = root.getAttribute("data-shop");
    const productId = root.getAttribute("data-product-id");
    const perPage = Number(root.getAttribute("data-per-page") || 10);
    if (!shop || !productId || !grid) return;

    let page = 1;
    let total = Number(root.getAttribute("data-count") || 0);

    const renderCards = (reviews) => {
      grid.innerHTML = reviews
        .map((r) => {
          const title = r.title
            ? "<h3>" + r.title.replace(/</g, "") + "</h3>"
            : "";
          const verified = r.verified ? '<span>Verified purchase</span>' : "";
          const date = formatReviewDate(r.date);
          return (
            '<article class="review-card">' +
            starRow(r.score) +
            title +
            "<p>" +
            (r.body || "").replace(/</g, "") +
            "</p>" +
            "<footer><b>" +
            (r.author || "Anonymous").replace(/</g, "") +
            "</b>" +
            verified +
            (date ? '<div class="review-card__date">' + date + "</div>" : "") +
            "</footer></article>"
          );
        })
        .join("");
    };

    const renderPager = () => {
      const pages = Math.max(1, Math.ceil(total / perPage));
      if (pages <= 1) {
        pager.hidden = true;
        return;
      }
      pager.hidden = false;
      pager.innerHTML = pagerButtons(page, pages)
        .map((item) => {
          if (item.gap) return '<span class="jlive__gap">…</span>';
          const disabled =
            (item.label === "Prev" && page === 1) || (item.label === "Next" && page === pages);
          return (
            '<button type="button" class="jlive__page' +
            (item.current ? " is-current" : "") +
            '" data-page="' +
            item.n +
            '"' +
            (disabled ? " disabled" : "") +
            ">" +
            item.label +
            "</button>"
          );
        })
        .join("");
    };

    const load = async (nextPage) => {
      grid.classList.add("is-loading");
      error.hidden = true;
      try {
        const url =
          "https://api.judge.me/reviews/reviews_for_widget?shop_domain=" +
          encodeURIComponent(shop) +
          "&platform=shopify&page=" +
          nextPage +
          "&per_page=" +
          perPage +
          "&product_id=" +
          encodeURIComponent(productId);
        const res = await fetch(url);
        if (!res.ok) throw new Error("Judge.me " + res.status);
        const data = await res.json();
        const reviews = parseJudgeReviews(data.html || "");
        if (data.total_count) total = Number(data.total_count);
        page = Number(data.page || nextPage);
        if (countEl) {
          const rating = root.getAttribute("data-rating") || "4.4";
          countEl.textContent = rating + "/5 from " + total.toLocaleString() + " reviews";
        }
        if (scoreEl && root.getAttribute("data-rating")) {
          scoreEl.textContent = String(Number(root.getAttribute("data-rating"))).replace(/0+$/, "").replace(/\.$/, "");
        }
        renderCards(reviews);
        renderPager();
      } catch (e) {
        error.hidden = false;
        grid.innerHTML = "";
      } finally {
        grid.classList.remove("is-loading");
      }
    };

    pager.addEventListener("click", (e) => {
      const btn = e.target.closest("[data-page]");
      if (!btn || btn.disabled) return;
      const next = Number(btn.getAttribute("data-page"));
      if (!next || next === page) return;
      load(next).then(() => {
        root.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    });

    load(1);
  }

  function initHeader() {
    const header = document.querySelector(".site-header");
    if (!header) return;
    const stickyMode = header.getAttribute("data-sticky") || "on_scroll_up";
    const transparent = header.classList.contains("is-transparent");
    if (stickyMode === "never" && !transparent) return;

    const extraSpace = () => {
      const announce = document.querySelector(".announce");
      return (announce ? announce.offsetHeight : 0) + 20;
    };
    let lastScroll = window.scrollY || 0;

    const update = () => {
      const y = window.scrollY || 0;
      const headerH = header.offsetHeight;
      const extra = extraSpace();

      if (y <= extra) {
        header.classList.remove("is-stuck", "is-hidden");
        lastScroll = y;
        return;
      }

      if (stickyMode === "never") {
        header.classList.remove("is-stuck", "is-hidden");
        lastScroll = y;
        return;
      }

      header.classList.add("is-stuck");

      if (stickyMode === "always") {
        header.classList.remove("is-hidden");
      } else if (!document.body.classList.contains("drawer-lock")) {
        if (y > headerH + extra && y > lastScroll + 4) {
          header.classList.add("is-hidden");
        } else if (y < lastScroll - 4) {
          header.classList.remove("is-hidden");
        }
      } else {
        header.classList.remove("is-hidden");
      }
      lastScroll = y;
    };

    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    update();
  }

  function initPopup() {
    const root = document.querySelector("[data-rpop]");
    const teaser = document.querySelector("[data-rpop-teaser]");
    if (!root) return;

    // Bump this when Klaviyo publishes a newer stable revision.
    const KLAVIYO_REVISION = "2026-07-15";
    const KEY = "ranch-popup";
    const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

    let saved = null;
    try {
      saved = JSON.parse(localStorage.getItem(KEY) || "null");
    } catch (e) {}
    if (saved && saved.claimed) return;

    const emailCode = root.getAttribute("data-code-email") || "ANGUS10";
    const phoneCode = root.getAttribute("data-code-phone") || "ANGUS15";
    const delay = Math.max(1, Number(root.getAttribute("data-delay") || 5)) * 1000;
    const listEmail = root.getAttribute("data-klaviyo-list-email") || "";
    const listSms = root.getAttribute("data-klaviyo-list-sms") || "";
    const msgEmail = root.getAttribute("data-msg-email") || "Enter a valid email address.";
    const msgPhone = root.getAttribute("data-msg-phone") || "Enter a 10-digit mobile number.";
    const msgGeneric = root.getAttribute("data-msg-generic") || "That did not go through. Try again.";

    let email = "";
    let phone = "";
    let lastFocus = null;

    // --- Klaviyo company id -------------------------------------------------
    // Prefer the theme setting. Scraping script tags only works when the onsite
    // snippet happens to carry ?company_id=, which the Shopify app version does
    // not always do — that silent miss is what stopped every subscribe call.
    const scrapeCompanyId = () => {
      try {
        const scripts = document.querySelectorAll("script[src]");
        for (let i = 0; i < scripts.length; i++) {
          const src = scripts[i].src || "";
          if (!/klaviyo/i.test(src)) continue;
          const q = src.match(/[?&]company_id=([A-Za-z0-9]+)/);
          if (q) return q[1];
          const p = src.match(/\/onsite\/js\/([A-Za-z0-9]{6})\//);
          if (p) return p[1];
        }
      } catch (e) {}
      return "";
    };
    const companyId = root.getAttribute("data-klaviyo-company") || scrapeCompanyId();
    if (!companyId) {
      console.warn("[rpop] No Klaviyo public API key — nobody will be subscribed to Klaviyo.");
    }
    if (!listEmail || !listSms) {
      console.warn("[rpop] Missing Klaviyo list ID — profiles will not join a list, so list-triggered flows will not fire.");
    }

    // --- steps --------------------------------------------------------------
    const stepEls = () => root.querySelectorAll("[data-rpop-step]");
    const step = (name) => {
      stepEls().forEach((el) => {
        const on = el.getAttribute("data-rpop-step") === name;
        el.hidden = !on;
        if (on) {
          const h = el.querySelector("h2[id]");
          if (h) root.setAttribute("aria-labelledby", h.id);
        }
      });
      setError(name, "");
    };
    const setError = (name, msg) => {
      const el = root.querySelector('[data-rpop-step="' + name + '"] [data-rpop-error]');
      if (!el) return;
      el.textContent = msg || "";
      el.hidden = !msg;
    };
    const lock = (btn, on) => {
      if (!btn) return;
      if (on) {
        if (!btn.dataset.rpopLabel) btn.dataset.rpopLabel = btn.textContent;
        btn.disabled = true;
        btn.textContent = "Sending…";
      } else {
        btn.disabled = false;
        if (btn.dataset.rpopLabel) btn.textContent = btn.dataset.rpopLabel;
      }
    };
    const store = (patch) => {
      try {
        const cur = JSON.parse(localStorage.getItem(KEY) || "{}");
        localStorage.setItem(KEY, JSON.stringify({ ...cur, ...patch }));
      } catch (e) {}
    };

    // --- teaser -------------------------------------------------------------
    const placeTeaser = () => {
      if (!teaser || teaser.hidden) return;
      const bar = document.querySelector("[data-sticky-atc]");
      let lift = 0;
      if (bar && bar.classList.contains("is-visible")) {
        const cs = getComputedStyle(bar);
        if (cs.display !== "none") lift = Math.round(bar.getBoundingClientRect().height);
      }
      teaser.style.bottom =
        "calc(" + (lift ? lift + 12 : 14) + "px + env(safe-area-inset-bottom, 0px))";
    };
    const showTeaser = () => {
      if (!teaser) return;
      try {
        const cur = JSON.parse(localStorage.getItem(KEY) || "{}");
        if (cur.teaserHidden) return;
      } catch (e) {}
      teaser.hidden = false;
      placeTeaser();
    };
    const hideTeaser = () => {
      if (teaser) teaser.hidden = true;
    };

    // --- open / close -------------------------------------------------------
    const show = () => {
      if (!root.hidden) return;
      hideTeaser();
      lastFocus = document.activeElement;
      root.hidden = false;
      document.body.classList.add("drawer-lock");
      window.setTimeout(() => {
        const live = root.querySelector("[data-rpop-step]:not([hidden])");
        const items = live ? focusable(live) : [];
        (items[0] || root.querySelector(".rpop__x")).focus();
      }, 30);
    };
    const hide = (reason) => {
      root.hidden = true;
      if (!document.querySelector(".drawer-root.is-open")) {
        document.body.classList.remove("drawer-lock");
      }
      if (lastFocus && typeof lastFocus.focus === "function") lastFocus.focus();
      if (reason === "claimed") {
        hideTeaser();
        return;
      }
      store({ dismissed: Date.now() });
      showTeaser();
    };

    // --- Klaviyo ------------------------------------------------------------
    const klaviyoIdentify = (payload) => {
      try {
        if (window.klaviyo && typeof window.klaviyo.identify === "function") {
          window.klaviyo.identify(payload);
        } else if (window.klaviyo && typeof window.klaviyo.push === "function") {
          window.klaviyo.push(["identify", payload]);
        } else if (window._learnq) {
          window._learnq.push(["identify", payload]);
        }
      } catch (e) {}
    };

    // Returns { ok, status, detail }. Never throws.
    // Note: consented_at is deliberately omitted — passing it on the client
    // endpoint requires historical_import and returns a 400.
    const klaviyoSubscribe = async (profileAttrs, channels, listId, source) => {
      if (!companyId) return { ok: false, status: 0, detail: "missing company_id" };
      const subscriptions = {};
      if (channels.indexOf("email") !== -1) {
        subscriptions.email = { marketing: { consent: "SUBSCRIBED" } };
      }
      if (channels.indexOf("sms") !== -1) {
        subscriptions.sms = { marketing: { consent: "SUBSCRIBED" } };
      }
      const attributes = Object.assign({}, profileAttrs, { subscriptions: subscriptions });
      const payload = {
        data: {
          type: "subscription",
          attributes: {
            custom_source: source,
            profile: { data: { type: "profile", attributes: attributes } },
          },
        },
      };
      if (listId) {
        payload.data.relationships = { list: { data: { type: "list", id: listId } } };
      }
      try {
        const res = await fetch(
          "https://a.klaviyo.com/client/subscriptions/?company_id=" + encodeURIComponent(companyId),
          {
            method: "POST",
            headers: { "Content-Type": "application/json", revision: KLAVIYO_REVISION },
            body: JSON.stringify(payload),
          }
        );
        if (!res.ok) {
          let detail = "";
          try {
            const body = await res.json();
            detail = (body.errors && body.errors[0] && body.errors[0].detail) || "";
          } catch (e) {}
          console.warn("[rpop] Klaviyo " + res.status + " " + detail);
          return { ok: false, status: res.status, detail: detail };
        }
        return { ok: true, status: res.status, detail: "" };
      } catch (e) {
        console.warn("[rpop] Klaviyo request failed", e);
        return { ok: false, status: 0, detail: "network" };
      }
    };

    // --- Shopify ------------------------------------------------------------
    // Native submit into the hidden iframe keeps Shopify's bot protection,
    // which a hand-rolled fetch to /contact would drop.
    const newsletter = (emailVal, e164, tags) => {
      const formId = root.getAttribute("data-shopify-form-id");
      const shopifyForm = formId ? document.getElementById(formId) : null;
      if (!shopifyForm || !emailVal) return;
      const emailEl = shopifyForm.querySelector("[data-rpop-shopify-email]");
      const tagsEl = shopifyForm.querySelector("[data-rpop-shopify-tags]");
      const phoneEl = shopifyForm.querySelector("[data-rpop-shopify-phone]");
      if (emailEl) emailEl.value = emailVal;
      if (tagsEl) tagsEl.value = tags || "newsletter";
      if (phoneEl) {
        // Attaches the number to the customer record. Does NOT grant SMS
        // marketing consent in Shopify — that lives in Klaviyo only.
        if (e164) {
          phoneEl.value = e164;
          phoneEl.disabled = false;
        } else {
          phoneEl.value = "";
          phoneEl.disabled = true;
        }
      }
      try {
        shopifyForm.submit();
      } catch (e) {
        console.warn("[rpop] Shopify newsletter submit failed", e);
      }
    };

    // --- phone helpers ------------------------------------------------------
    const nationalDigits = (raw) => {
      let d = String(raw || "").replace(/\D/g, "");
      if (d.length === 11 && d.charAt(0) === "1") d = d.slice(1);
      if (d.length > 10) d = d.slice(-10);
      return d.slice(0, 10);
    };
    const formatNational = (d) => {
      if (!d) return "";
      if (d.length < 4) return "(" + d;
      if (d.length < 7) return "(" + d.slice(0, 3) + ") " + d.slice(3);
      return "(" + d.slice(0, 3) + ") " + d.slice(3, 6) + "-" + d.slice(6);
    };

    // --- done ---------------------------------------------------------------
    const paintDone = (pct) => {
      const done = root.querySelector('[data-rpop-step="done"]');
      const badge = root.querySelector("[data-rpop-done-badge]");
      const title = root.querySelector("[data-rpop-done-title]");
      const body = root.querySelector("[data-rpop-done-body]");
      const pick = (name) => (done && done.getAttribute("data-" + name + "-" + pct)) || "";
      if (badge) badge.textContent = pick("badge");
      if (title) title.textContent = pick("title");
      if (body) {
        body.textContent = pick("body")
          .replace("[email]", email || "you")
          .replace("[phone]", phone ? "+1 " + formatNational(phone) : "your phone")
          .replace("[code]", pct === 15 ? phoneCode : emailCode);
      }
      store({ claimed: true, pct: pct });
      step("done");
      window.setTimeout(() => {
        const shopBtn = root.querySelector("[data-rpop-shop]");
        if (shopBtn) shopBtn.focus();
      }, 30);
    };

    // --- boot ---------------------------------------------------------------
    if (saved && saved.dismissed) {
      showTeaser();
    } else {
      window.setTimeout(show, delay);
    }

    if (teaser) {
      teaser.addEventListener("click", (e) => {
        if (e.target.closest("[data-rpop-teaser-hide]")) {
          e.preventDefault();
          hideTeaser();
          store({ teaserHidden: true });
          return;
        }
        show();
      });
    }

    root.addEventListener("click", (e) => {
      if (e.target.closest("[data-rpop-dismiss]")) {
        e.preventDefault();
        hide("dismiss");
        return;
      }
      const next = e.target.closest("[data-rpop-next]");
      if (next) {
        e.preventDefault();
        step(next.getAttribute("data-rpop-next"));
        const input = root.querySelector("[data-rpop-step]:not([hidden]) input:not([data-rpop-hp])");
        if (input) input.focus();
        return;
      }
      if (e.target.closest("[data-rpop-keep-10]")) {
        e.preventDefault();
        paintDone(10);
        return;
      }
      const shop = e.target.closest("[data-rpop-shop]");
      if (shop) {
        hide("claimed");
        const href = shop.getAttribute("href") || "#shop";
        if (href.charAt(0) === "#") {
          e.preventDefault();
          const el = document.querySelector(href);
          if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }
    });

    // --- email step ---------------------------------------------------------
    const emailForm = root.querySelector("[data-rpop-email]");
    if (emailForm) {
      emailForm.addEventListener("submit", async (e) => {
        e.preventDefault();
        const input = emailForm.querySelector('input[type="email"]');
        const btn = emailForm.querySelector("[data-rpop-submit]");
        const hp = emailForm.querySelector("[data-rpop-hp]");
        const value = ((input && input.value) || "").trim();

        if (hp && hp.value) {
          // Honeypot filled: bot. Show the success shape, send nothing.
          email = value;
          paintDone(10);
          return;
        }
        if (!EMAIL_RE.test(value)) {
          setError("email", msgEmail);
          if (input) input.focus();
          return;
        }

        setError("email", "");
        lock(btn, true);
        email = value;

        newsletter(email, "", "newsletter, popup-email, angus10");
        klaviyoIdentify({ email: email, ranch_offer: "angus10", $source: "Ranch popup" });
        const res = await klaviyoSubscribe(
          { email: email },
          ["email"],
          listEmail,
          "Ranch popup — email step"
        );
        lock(btn, false);

        // A 400 means Klaviyo rejected the address, so keep them here to fix
        // it. Anything else (network, outage) should not cost us the lead —
        // Shopify already has them.
        if (!res.ok && res.status === 400) {
          setError("email", res.detail || msgEmail);
          if (input) input.focus();
          return;
        }
        if (!res.ok) store({ klaviyoEmailFailed: true, email: email });

        step("phone");
        const phoneField = root.querySelector("[data-rpop-phone-input]");
        if (phoneField) phoneField.focus();
      });
    }

    // --- phone step ---------------------------------------------------------
    const phoneForm = root.querySelector("[data-rpop-phone]");
    const phoneInput = root.querySelector("[data-rpop-phone-input]");
    if (phoneInput) {
      phoneInput.addEventListener("input", () => {
        phoneInput.value = formatNational(nationalDigits(phoneInput.value));
      });
    }
    if (phoneForm) {
      phoneForm.addEventListener("submit", async (e) => {
        e.preventDefault();
        const btn = phoneForm.querySelector("[data-rpop-submit]");
        const d = nationalDigits(phoneInput && phoneInput.value);
        if (d.length < 10) {
          setError("phone", msgPhone);
          if (phoneInput) phoneInput.focus();
          return;
        }

        setError("phone", "");
        lock(btn, true);
        const e164 = "+1" + d;

        newsletter(email, e164, "newsletter, popup-sms, angus15");
        klaviyoIdentify({
          email: email,
          phone_number: e164,
          ranch_offer: "angus15",
          $source: "Ranch popup",
        });
        // Email is sent for identity resolution only. Klaviyo subscribes just
        // the channels named in the subscriptions object, so this does not
        // re-consent email.
        const res = await klaviyoSubscribe(
          { email: email, phone_number: e164 },
          ["sms"],
          listSms,
          "Ranch popup — SMS step"
        );
        lock(btn, false);

        if (!res.ok && res.status === 400) {
          setError("phone", res.detail || msgPhone);
          if (phoneInput) phoneInput.focus();
          return;
        }
        if (!res.ok) store({ klaviyoSmsFailed: true, phone: e164 });

        phone = d;
        paintDone(15);
      });
    }

    // --- keyboard -----------------------------------------------------------
    root.addEventListener("keydown", (e) => {
      if (root.hidden) return;
      if (e.key === "Escape") {
        e.preventDefault();
        hide("dismiss");
        return;
      }
      if (e.key !== "Tab") return;
      const card = root.querySelector(".rpop__card");
      const items = focusable(card).filter(
        (el) => !el.closest("[hidden]") && !el.hasAttribute("data-rpop-hp")
      );
      if (!items.length) return;
      const first = items[0];
      const last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });

    window.addEventListener("resize", placeTeaser);
  }

  function boot() {
    initDrawers();
    initOffer();
    initAccordion();
    initSticky();
    initJLive();
    initHeader();
    initPopup();
    fetchCart().then(renderCart).catch(() => {});
    document.addEventListener("ranch:cart:add", async (event) => {
      try {
        const cart =
          event.detail && typeof event.detail.item_count === "number"
            ? event.detail
            : await fetchCart();
        renderCart(cart);
        openDrawer("cart");
      } catch (err) {
        /* keep drawer closed on refresh failure */
      }
    });
    window.ranchRefreshCart = async function () {
      const cart = await fetchCart();
      renderCart(cart);
      return cart;
    };
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();